import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleGuard } from '../../guard/auth-guard/role.guard';
import { Role } from '../../core/enums/role.enum';
import { alteracoesNaoSalvasGuard } from '../../core/guards/alteracoes-nao-salvas.guard';

const TODAS_PERMISSOES_REG_ATIVIDADE = [
  Role.REG_ATIVIDADE_VISUALIZAR,
  Role.REG_ATIVIDADE_REGISTRAR,
  Role.REG_ATIVIDADE_FINALIZAR,
  Role.REG_ATIVIDADE_RELATORIO_PDF,
];

export const registroAtividadeProfissionalRoutes: Routes = [
  {
    path: 'pagamento/registro-atividade-profissional',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      title: 'Registros de Atividade do Profissional',
      roles: TODAS_PERMISSOES_REG_ATIVIDADE,
      breadcrumb: [
        { label: 'Pagamento', url: '/pagamento' },
        { label: 'Registrar Atividade do Profissional', url: '/pagamento/registro-atividade-profissional' },
      ],
    },
    loadComponent: () =>
      import('./registro-atividade-tela-inicial.component').then(
        (m) => m.RegistroAtividadeTelaInicialComponent,
      ),
  },
  {
    path: 'pagamento/registro-atividade-profissional/competencia/:coSeqMes/profissionais',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      title: 'Registrar Atividades dos Profissionais',
      roles: TODAS_PERMISSOES_REG_ATIVIDADE,
      breadcrumb: [
        { label: 'Pagamento', url: '/pagamento' },
        { label: 'Registrar Atividade do Profissional', url: '/pagamento/registro-atividade-profissional' },
        { label: 'Profissionais' },
      ],
    },
    loadComponent: () =>
      import('./lista-profissionais/lista-profissionais.component').then(
        (m) => m.ListaProfissionaisComponent,
      ),
  },
  {
    path: 'pagamento/registro-atividade-profissional/competencia/:coSeqMes/afastado/:coInscricaoCiclo/visualizar',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      title: 'Visualizar Registro do Profissional',
      roles: TODAS_PERMISSOES_REG_ATIVIDADE,
      breadcrumb: [
        { label: 'Pagamento', url: '/pagamento' },
        { label: 'Registrar Atividade do Profissional', url: '/pagamento/registro-atividade-profissional' },
        { label: 'Visualizar' },
      ],
    },
    loadComponent: () =>
      import('./detalhe-profissional-afastado/detalhe-profissional-afastado.component').then(
        (m) => m.VisualizarAfastadoComponent,
      ),
  },
  {
    path: 'pagamento/registro-atividade-profissional/competencia/:coSeqMes/ativo/:coInscricaoCiclo/visualizar',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      title: 'Visualizar Registro do Profissional',
      roles: TODAS_PERMISSOES_REG_ATIVIDADE,
      breadcrumb: [
        { label: 'Pagamento', url: '/pagamento' },
        { label: 'Registrar Atividade do Profissional', url: '/pagamento/registro-atividade-profissional' },
        { label: 'Visualizar' },
      ],
    },
    loadComponent: () =>
      import('./detalhe-profissional-ativo/detalhe-profissional-ativo.component').then(
        (m) => m.VisualizarAtivoComponent,
      ),
  },
  {
    path: 'pagamento/registro-atividade-profissional/competencia/:coSeqMes/registrar',
    canActivate: [AuthGuard, RoleGuard],
    canDeactivate: [alteracoesNaoSalvasGuard],
    data: {
      title: 'Registrar Atividade do Profissional',
      roles: [Role.REG_ATIVIDADE_REGISTRAR],
      breadcrumb: [
        { label: 'Pagamento', url: '/pagamento' },
        { label: 'Registrar Atividade do Profissional', url: '/pagamento/registro-atividade-profissional' },
        { label: 'Registrar' },
      ],
    },
    loadComponent: () =>
      import('./situacao-atividade-profissional/situacao-atividade-profissional.component').then(
        (m) => m.RegistrarSituacaoComponent,
      ),
  },
];
